var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 40H101v167.6h32.5V40z",
    fill: "#ff8600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2 51.3H169v142.6h11.2V51.3z",
    fill: "#0065b1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101 74.6H68.7v111.5H101V74.6z",
    fill: "#e90a0a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169 61.3h-35.5v139.6H169V61.3z",
    fill: "#ae0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.8 103.9h-19.6v68h19.6v-68z",
    fill: "#008520"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 195c3.4-1.3 7.1-1.1 10.7-1.3 3.6-.2 7.5-1 10-3.5-3.3-1-7.4 1.6-7.9 5 0 .6 0 1.2.2 1.7.7 1.1 2.3 1 3.4.7 4.9-1.1 9.7-2.2 14.7-3.2-.9.8-1.6 1.8-1.9 3 8.6.2 14-1 22.5-.8",
    fill: "none",
    stroke: "#26221e",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201 67.6l-5.9 9.9-42.8-24.3 10.9-20.5",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.4 86.6l5.1-7.7c2.9-5-4.3-14.6-16.1-21.5-11.8-6.8-23.7-8.3-26.6-3.2l-3.6 5.9",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.7 130.7l34.5-48.2c2.9-5-4.3-14.6-16.1-21.5-11.8-6.8-23.7-8.3-26.6-3.2l-26.9 49.7",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 138.8l3-5.2c2.8-4.3-3.2-13.3-13.6-19.8-10.2-6.6-20.9-8.4-23.6-4l-3 5.2",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.8 138.8c2.8-4.3-3.3-13.2-13.5-19.8-10.3-6.6-20.8-8.4-23.6-4-2.8 4.3 3.3 13.2 13.5 19.8 10.3 6.6 20.8 8.4 23.6 4zm35.6-52.2c2.9-5-4.3-14.6-16.1-21.5-11.8-6.8-23.6-7.4-26.6-2.4",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M176.3 67.2s-18.6 29.1-24.4 39c-5.7 9.8-8.7 7.7-13.8 4.8-5.1-2.9-4.8-5.1-4.8-6.7s23.3-44.6 23.3-44.6 12.6 1.9 19.7 7.5zm-54.7 54.6s12-6.2 22.6 8.8c0 0-13.2 25.7-16.6 39.9 0 0-26.8 11-36.2 26 0 0 4.1-23.8 2-32.7-.2 0 17.8-28.5 28.2-41.9v-.1z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.1 130.5l-.6 9.2s-11 10.2-16 30.7c0 0 8.3-30.7 16.6-39.9z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.8 54.3l11.4-21.5M201 67.6l-5.9 9.9m-5.7 9.1l5.1-7.7c2.9-5-4.3-14.6-16.1-21.5-11.8-6.8-23.7-8.3-26.6-3.2l-3.6 5.9",
    fill: "none",
    stroke: "#26221e",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 131l34.7-48.5c2.9-5-4.3-14.6-16.1-21.5-11.8-6.8-23.7-8.3-26.6-3.2l-26.9 49.7",
    fill: "none",
    stroke: "#26221e",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.9 138.8l3-5.2c2.8-4.3-3.2-13.3-13.6-19.8-10.2-6.6-20.9-8.4-23.6-4l-3 5.2",
    fill: "none",
    stroke: "#26221e",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M119.1 124.8c-2.9-3.9-3.9-7.5-2.4-9.8 2.8-4.3 13.4-2.6 23.6 4 10.3 6.6 16.3 15.4 13.5 19.8-1.6 2.5-5.7 3-10.8 1.7m46.4-53.9c2.9-5-4.3-14.6-16.1-21.5-11.8-6.8-23.6-7.4-26.6-2.4",
    fill: "none",
    stroke: "#26221e",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.3 67.2s-18.6 29.1-24.4 39c-5.7 9.8-8.7 7.7-13.8 4.8-5.1-2.9-4.8-5.1-4.8-6.7s23.3-44.6 23.3-44.6 12.6 1.9 19.7 7.5zm-48.7 103.2s-26.8 11-36.2 26c0 0 4.1-23.8 2-32.7-.2 0 17.8-28.5 28.2-41.9 0 0 12-6.2 22.6 8.8 0 0 0 .1-.3.7m-52.6 65.2l18.7-36.6",
    fill: "none",
    stroke: "#26221e",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.1 130.5l-.6 9.2s-11 10.2-16 30.7c0 0 8.3-30.7 16.6-39.9h0z",
    fill: "none",
    stroke: "#26221e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.2 175.4l-12.5 7.7-5.4 4.3-4.3 4.2s9.7-6.5 22.1-9.3c1.6-.4 3-1.4 3.8-2.9l5-8.5-8.9 4.5h.2zm10.9-7.9l16-26.9-1.3-.6-2.1 2.7-3.8 5.3-3.6 6.3-2.7 6.1m-20.6 2.1c1.5 0 2.7-1.2 2.7-2.7s-1.2-2.7-2.7-2.7-2.7 1.2-2.7 2.7 1.2 2.7 2.7 2.7z",
    fill: "#26221e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.138873092d4777bbe9702b0ce4f0bd98.svg";
export { ForwardRef as ReactComponent };